var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"community-layout"},[_c('router-view',{key:_vm.$route.path})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }